<template>
    <v-layout>
        <v-main>
            <v-container>
                <v-card v-if="kittenFound" class="text-h6" style="padding: 1em !important">
                    <div class="name-div">Name: Joking Heroes' {{ kitten }}</div>
                    <div>Geburtstag: {{ kittenData.birthday }}</div>
                    <div>Farbe:
                        <v-tooltip>
                            <template v-slot:activator="{ props }">
                                <v-btn v-bind="props">
                                    {{ kittenData.color }}
                                </v-btn>
                            </template>
                            <div v-for="line in kittenData.colorDetails" :key="line">{{ line }}</div>
                        </v-tooltip>
                    </div>
                    <div>EMS Code: {{ kittenData.ems }}
                    </div>
                    <div>Eltern:
                        <u>
                            <router-link v-if="!kittenData.parent_sire.external" :to="kittenData.parent_sire.link">{{
                                kittenData.parent_sire.name }}</router-link>
                            <a v-if="kittenData.parent_sire.external" :href="kittenData.parent_sire.link">{{
                                kittenData.parent_sire.name }}</a>
                        </u>
                        &amp;
                        <u>
                            <router-link v-if="!kittenData.parent_dam.external" :to="kittenData.parent_dam.link">{{
                                kittenData.parent_dam.name }}</router-link>
                            <a v-if="kittenData.parent_dam.external" :href="kittenData.parent_dam.link">{{
                                kittenData.parent_dam.name }}</a>
                        </u>
                    </div>
                    <div>Wurf: {{ kittenData.wurf }}</div>
                    <div style="margin-top: 1em; margin-bottom: 1em;">{{ kittenData.description }}</div>
                    <div>Bilder:</div>
                    <div v-for="kittenimage in kittenData.photos" :key="kittenimage.path">
                        <v-card class="mx-auto" max-width="400px" style="margin-top: 1em; margin-bottom: 1em;">
                            <v-card-title>{{ kittenimage.text }}</v-card-title>
                            <v-img cover :lazy-src="convertPathToSource(kittenimage.path, true)" :src="convertPathToSource(kittenimage.path, false)"></v-img>
                        </v-card>
                    </div>
                </v-card>
                <v-card v-if="!kittenFound" class="text-h6" style="padding: 1em !important">
                    Kein Kitten namens "{{ kitten }} gefunden :(
                </v-card>
            </v-container>
        </v-main>
    </v-layout>
</template>

<script>
import { useKittenStore } from "../store/kitten"

export default {
    components: {
    },
    setup() {
        const kittenStore = useKittenStore();
        return { kittenStore };
    },
    created() {
        this.updateKittenData();
    },
    beforeUpdate() {
        this.updateKittenData();
    },
    methods: {
        updateKittenData() {
            if (this.kitten) {
                let kittenData = this.kittenStore;
                this.kittenData = kittenData.kitten[this.kitten];
                if (this.kittenData) { this.kittenFound = true }
            }
        },
        convertPathToSource(path, thumb) {
            var name = path;
            if (thumb) {
                name = name + ".thumb.jpg"
            }

            if (process.env.NODE_ENV === 'development') {
                return require("@/assets/static/kitten/" + this.kitten.toLowerCase() + "/" + name);
            } else {
                return "https://static.jokingheroes.de/kitten/" + this.kitten.toLowerCase() + "/" + name;
            }
        }
    },
    props: [
        'kitten',
    ],
    data() {
        return {
            kittenData: {},
            kittenFound: false,
        }
    },
}
</script>

<style>
.name-div {
    text-transform: capitalize;
}</style>
